import React from "react";
import { getBrokenLinkUrl } from "../../../common/utils";
import { isURL } from "../../../_editor/components/clipboard/clipboard.utils";
/* eslint-disable react/prop-types */

export default class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasImageError: false, // Sonsuz döngüyü önlemek için
    };
    this.brokenLinkUrl = getBrokenLinkUrl();
    this.draggableImageVisorRef = React.createRef();
    this.imgRef = React.createRef();
  }
  render() {
    let { state, props, markElements } = this.props;
    let hyperlink = this.checkHyperlink(state.hyperlink);
    let scale = state.scale || 1;
    let translateX = (state.translate ? state.translate.x : 0) || 0;
    let translateY = (state.translate ? state.translate.y : 0) || 0;
    let transform = `translate(${translateX}%,${translateY}%) scale(${scale})`;

    let imageHeight = state.allowDeformed ? "100%" : "auto";

    // Resim hatası varsa broken_link göster, yoksa normal URL kullan
    const imageSrc = this.state.hasImageError ? this.brokenLinkUrl : state.url;

    const imageElement = (
      <img
        ref={this.imgRef}
        className="basicImageClass"
        style={{
          overflow: "hidden",
          width: state.allowDeformed ? "100%" : "100%",
          height: imageHeight,
          transform,
          WebkitTransform: transform,
          MozTransform: transform,
        }}
        src={imageSrc}
        onError={(e) => {
          // Sonsuz döngüyü önle - sadece bir kez hata işle
          if (!this.state.hasImageError) {
            e.target.onerror = null; // Küçük harf - DOM property
            this.setState({ hasImageError: true });
          }
        }}
      />
    );

    return (
      <div style={{ overflow: "hidden", height: "100%", width: "100%" }} className="boxStyle">
        <div
          style={{ overflow: "hidden", height: "100%", width: "100%" }}
          className="draggableImageVisor"
          ref={this.draggableImageVisorRef}
        >
          {hyperlink ? (
            <a href={hyperlink} target="_blank" style={{ height: "100%", display: "block" }}>
              {imageElement}
              {markElements}
            </a>
          ) : (
            <div style={{ height: "100%", width: "100%" }}>
              {imageElement}
              {markElements}
            </div>
          )}
        </div>
      </div>
    );
  }

  componentDidMount() {
    let scale = this.props.state.scale || 1;
  }

  // Checks if link is provided. If so, it formats it to 'http://www...' in case it was 'www...'. Returns false if no link is provided.
  checkHyperlink(hyperlink) {
    if (hyperlink === null || hyperlink === undefined) {
      return false;
    }
    hyperlink = hyperlink.replace(/\s/g, "");
    if (hyperlink === "") {
      return false;
    }
    if (hyperlink.substring(0, 4) === "www.") {
      hyperlink = "http://" + hyperlink;
    }
    if (isURL(hyperlink)) {
      return hyperlink;
    }
    return false;
  }
}
/* eslint-enable react/prop-types */
